module.exports = __webpack_public_path__ + "img/narapark.75daa60a.jpg";